import styles from './Hotspot.module.css';
import { Html } from '@react-three/drei';
import { HOTSPOT_TYPES } from "../../../hooks/store/Types";
import { useAppStore } from '../../../hooks/store/useAppStore';
import { sceneHotspotErrorSelector } from '../../../hooks/store/getters';
import { BsExclamationTriangle } from "react-icons/bs"
const HOTSPOT_ICON = "https://s3-us-east-2.amazonaws.com/ve-dev/df303002-7ae5-4a6c-ac2e-518ec38f27ac.gif"

const HOTSPOT_PIN = "https://s3-us-east-2.amazonaws.com/ve-dev/18da4c9b-256e-483f-a484-134accd01216.gif"

const DefaultHotspot = (props) => {
    const hotspots = useAppStore(sceneHotspotErrorSelector);
    const { hotspot, onClick } = props;
    const { index } = props;
    const { position: { x, y, z } } = hotspot;
    const hotSpoterror = hotspots ? hotspots[index] : null;
    let error = false;
    

    if(hotSpoterror) {
        if(hotspot.hotspotType === "data" && (hotSpoterror.name !== "" || hotSpoterror.description !== "")) {
            error = true;
        } else if(hotspot.hotspotType === "move" && (hotSpoterror.sceneIndex !== "" || hotSpoterror.name !== "")) {
            error = true;
        }
    }
   
    return (
        <Html 
            {...props} 
            scaleFactor={1} 
            position={[x, y, z]} 
            center 
            zIndexRange={[100, 99]}
            className={styles.hotspot}
        >   { error && (
            <span className={styles.hotspoterror} >
                 <BsExclamationTriangle></BsExclamationTriangle>
            </span>
            
            )}
            {hotspot.name && <span className={styles.hotspotDisplayName}> {hotspot.name} </span>}
            <div className={styles.hotspotImg}>
                <img 
                    src={hotspot.hotspotType === HOTSPOT_TYPES.MOVE ? HOTSPOT_PIN : HOTSPOT_ICON}
                    alt="hotspot" 
                    onClick={onClick} 
                />
                
            </div>
        </Html>
    );
};

export default DefaultHotspot;
